import React from 'react';

export const PURPLE_GRADIENT = 'linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)';
export const PURPLE_GRADIENT_DISABLED = 'linear-gradient(135deg, #c4b5fd 0%, #a78bfa 100%)';
export const SUCCESS_GRADIENT = 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)';

export const colors = {
    title: '#0f172a',
    body: '#111827',
    muted: '#4b5563',
    subtle: '#6b7280',
    placeholder: '#9ca3af',
    accent: '#6366f1',
    accentRing: 'rgba(99, 102, 241, 0.15)',
    success: '#059669',
    warning: '#f59e0b',
    danger: '#dc2626',
    dangerRing: 'rgba(220, 38, 38, 0.15)',
    border: '#e5e7eb',
    bgMuted: '#f3f4f6',
    boltGold: '#fbbf24'
};

export const shadows = {
    primaryButton: '0 6px 18px rgba(99, 102, 241, 0.35)',
    logoBadge: '0 8px 24px rgba(99, 102, 241, 0.35)',
    softCard: '0 24px 64px rgba(15, 23, 42, 0.12)',
    modal: '0 24px 64px rgba(15, 23, 42, 0.25)'
};

export const radii = {
    input: 10,
    button: 10,
    badge: 16,
    card: 20,
    pill: 9999
};

export const fieldLabelStyle: React.CSSProperties = {
    display: 'block',
    fontSize: 14,
    fontWeight: 600,
    color: colors.body,
    marginBottom: 8
};

export const formResetStyle: React.CSSProperties = {
    border: 'none',
    padding: 0,
    background: 'transparent',
    margin: 0,
    display: 'block',
    maxWidth: 'none'
};
